import { Dropdown, IDropdownOption, Stack, TextField, StackItem } from "@fluentui/react";

import { IFileInfo } from "ccs-azure";
import { AdditionalFormDLLEnum, AdditionalFormTXTEnum, SaveTypeEnum, ValidationType } from "components/Utility/AppEnums";
import { Utility } from "components/Utility/Utility";
import { AppTopContext } from "components/Welcome/Common/AppTopContext";
import { FileSizeMSG } from "components/Welcome/Common/FileSizeMSG";
import { AttachmentUploadIcon as AttachmentComponent } from "components/Welcome/Common/AttachmentUploadIcon";
import DataProvider from "dataprovider/DataProvider";
import { IAppFileInfo, INavigationActions, IReturnAction, IUserAdditionalData, IUserFieldsState } from "Interfaces/IHRBrazil";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppConstants } from "../../../../Utility/Constants";
import { ActionSection } from "./ActionSection";
import "./Additional.scss";
export interface IAdditionalFormProps {
  user: IUserFieldsState;
  isFormEditable: boolean;
  previousCall: any;
  nextCall: any;
  submitCall: any;
  userProfileFormData: IUserAdditionalData;
  navigationAction: INavigationActions;
  saveUserProfile: (sectionKey: string, data: any, updateData: boolean, callFunc: any) => void;
  updateFormMode: (formMode: boolean) => void;
}

export const AdditionalForm: React.FunctionComponent<IAdditionalFormProps> = ({ ...props }) => {
  const { t, i18n } = useTranslation(AppConstants.i18NameSpaces);
  const appContext = useContext(AppTopContext);
  let [_addressCountryOptions, _setAddressCountryOptions] = useState<IDropdownOption[]>([]);
  let [_maritalStatusOptions, _setMaritalStatusOptions] = useState<IDropdownOption[]>([]);
  let [_educationLevelOptions, _setEducationLevelOptions] = useState<IDropdownOption[]>([]);
  let [_publicAreaOptions, _setPublicAreaOptions] = useState<IDropdownOption[]>([]);
  var dataProvider = new DataProvider();

  useEffect(() => {}, []);
  useEffect(() => {
    var countryOptions = Utility.GetChoiceOptions(i18n.language, props, AppConstants.choices.Country);
    _setAddressCountryOptions(countryOptions);
    var maritalStatusOptions = Utility.GetChoiceOptions(i18n.language, props, AppConstants.choices.MaritalStatus);
    _setMaritalStatusOptions(maritalStatusOptions);

    var educationLevelOptions = Utility.GetChoiceOptions(i18n.language, props, AppConstants.choices.EducationLevel);
    _setEducationLevelOptions(educationLevelOptions);

    var publicAreaOptions = Utility.GetChoiceOptions(i18n.language, props, AppConstants.choices.PublicArea);
    _setPublicAreaOptions(publicAreaOptions);
  }, [appContext.IsLBrazil]);
  let [_isFileUpdated, _setIsFileUpdated] = useState<boolean>(false);
  let [_deletedDocs, _setDeletedDocs] = useState<Array<IFileInfo>>([]);
  let [_educationDocs, _setEducationDocs] = useState<Array<IFileInfo | File>>([]);
  let [_otherCertificates, _setOtherCertificates] = useState<Array<IFileInfo | File>>([]);
  let [_maritalDocs, _setMaritalDocs] = useState<Array<IFileInfo | File>>([]);
  let [_addressDocs, _setAddressDocs] = useState<Array<IFileInfo | File>>([]);
  let [_fieldErrors, _setFieldErrors] = useState<string[]>([]);
  let [_showErrors, _setShowErrors] = useState<boolean>(false);
  const [_userProfileFormData, _setUserProfileFormData] = useState<IUserAdditionalData>(Utility.GetInitialData(AppConstants.SectionKey.AdditionalData));
  useEffect(() => {
    if (props.navigationAction.Guid) {
      if (props.isFormEditable) {
        // Block left-nav navigation when required fields are empty.
        const navErrors = Utility.GetFieldErrors(AppConstants.SectionKey.AdditionalData, _userProfileFormData);
        if (_educationDocs.length === 0) {
          navErrors.push(t("UserAdditionalData.FormFields.EducationCertificate"));
        }
        if (_otherCertificates.length === 0) {
          navErrors.push(t("UserAdditionalData.FormFields.Certificate"));
        }
        if (_userProfileFormData?.MaritalStatus?.toLowerCase() !== AppConstants.maritalStatus.Single.toLowerCase() && _maritalDocs.length === 0) {
          navErrors.push(t("UserAdditionalData.FormFields.MaritalCert"));
        }
        if (_addressDocs.length === 0) {
          navErrors.push(t("UserAdditionalData.FormFields.ProofOfAddress"));
        }
        if (navErrors.length > 0) {
          _setFieldErrors(navErrors);
          _setShowErrors(true);
          return;
        }
        let isFormUpdated = Utility.IsFormUpdated(_isFileUpdated, AppConstants.SectionKey.AdditionalData, props.user, _userProfileFormData);
        if (appContext.IsUserAdmin) {
          if (isFormUpdated) {
            appContext.ShowAppModal(t("Information.AdminPanelAction.Header"), t("Information.AdminPanelAction.MSG"));
          } else {
            props.navigationAction.NavigationFun();
          }
        } else {
          callPropSaveDataCallBackFunction(isFormUpdated, props.navigationAction.NavigationFun);
        }
      } else {
        props.navigationAction.NavigationFun();
      }
    }
  }, [props.navigationAction.Guid]);
  useEffect(() => {
    initializeForm();
  }, [props.userProfileFormData]);

  function initializeForm() {
    let initialData = Utility.GetInitialData(AppConstants.SectionKey.AdditionalData, props.userProfileFormData) as IUserAdditionalData;
    _setEducationDocs(Utility.GetFiles(initialData.EducationCertificates));
    _setOtherCertificates(Utility.GetFiles(initialData.OtherCertificates));
    _setMaritalDocs(Utility.GetFiles(initialData.MaritalCert));
    _setAddressDocs(Utility.GetFiles(initialData.ProofOfAddress));
    _setUserProfileFormData(initialData);

    _setDeletedDocs([]);
  }
  function resetForm() {
    /// check for change and reset
    let isFormDataUpdated = Utility.IsFormUpdated(_isFileUpdated, AppConstants.SectionKey.AdditionalData, props.user, _userProfileFormData);
    if (isFormDataUpdated) {
      appContext.ShowAppConfirmationModal(
        t("ActionBtn.ExitEditModeConfirmation.Header"),
        t("ActionBtn.ExitEditModeConfirmation.MSG"),
        t("ActionBtn.ExitEditModeConfirmation.OKBtnTxt"),
        t("ActionBtn.ExitEditModeConfirmation.CancelBtnTxt"),
        function () {
          /// call reset data
          initializeForm();
        },
      );
    } else {
      props.updateFormMode(false);
    }
  }
  function callPropSaveDataCallBackFunction(isDataUpdateRequire: boolean, func: any) {
    appContext.ShowAppLoader(true, "");
    if (isDataUpdateRequire) {
      if (appContext.IsUserAdmin) {
        /// validate page data
        if (!Utility.IsAdditionalFormValidated(_userProfileFormData, ValidationType.FieldOnly)) {
          appContext.ShowAppModal(t("ModalDialogHeader.ValidationMessage"), t("ValidationMessage.RequiredFieldValidation"));
          appContext.ShowAppLoader(false, "");
          return;
        }
        let requiredDocs = [_educationDocs, _maritalDocs, _addressDocs, _otherCertificates];
        if (_userProfileFormData?.MaritalStatus?.toLowerCase() === AppConstants.maritalStatus.Single.toLowerCase()) {
          requiredDocs = [_educationDocs, _addressDocs, _otherCertificates];
        }
        if (!Utility.IsRequiredFormDocsPresent(requiredDocs)) {
          appContext.ShowAppModal(t("ModalDialogHeader.ValidationMessage"), t("ValidationMessage.RequiredFieldValidation"));
          appContext.ShowAppLoader(false, "");
          return;
        }
      }

      if (!Utility.IsFilesSizeValid([_educationDocs, _maritalDocs, _addressDocs, _otherCertificates])) {
        appContext.ShowAppModal(t("ModalDialogHeader.ValidationMessage"), t("ValidationMessage.FileSizeLimit"));
        appContext.ShowAppLoader(false, "");
        return;
      }

      dataProvider
        .deleteUserDocs(props.user.UserId, _deletedDocs)
        .then((delResponse: any) => {
          if (delResponse?.hasError) {
            console.log(delResponse);
            if (!Utility.IsUnauthorizeError(delResponse.errorDetail, appContext)) {
              appContext.ShowAppModal(t("ModalDialogHeader.Error"), t("Error.DocumentError.DocumentDeleteError"));
            }
            appContext.ShowAppLoader(false, "");
          } else {
            Promise.all([
              dataProvider.uploadUserDocs(props.user.UserId, AppConstants.AttachmentType.EducationDocs.Display, _educationDocs),
              dataProvider.uploadUserDocs(props.user.UserId, AppConstants.AttachmentType.MaritalDocs.Display, _maritalDocs),
              dataProvider.uploadUserDocs(props.user.UserId, AppConstants.AttachmentType.AddressDocs.Display, _addressDocs),
              dataProvider.uploadUserDocs(props.user.UserId, AppConstants.AttachmentType.OtherCertificates.Display, _otherCertificates),
            ])
              .then((res) => {
                let errorMSG = false;
                if (!res[0]?.hasError) {
                  _userProfileFormData.EducationCertificates = res[0].data as IAppFileInfo[];
                } else {
                  console.log(res[0]?.ErrorDetail);
                  errorMSG = true;
                }
                if (!res[1]?.hasError) {
                  _userProfileFormData.MaritalCert = res[1].data as IAppFileInfo[];
                } else {
                  console.log(res[1]?.ErrorDetail);
                  errorMSG = true;
                }
                if (!res[2]?.hasError) {
                  _userProfileFormData.ProofOfAddress = res[2].data as IAppFileInfo[];
                  if (_userProfileFormData.ProofOfAddress.length > 0) {
                    /// only single file require in json
                    _userProfileFormData.ProofOfAddress = [_userProfileFormData.ProofOfAddress[0]];
                  }
                } else {
                  console.log(res[2]?.ErrorDetail);
                  errorMSG = true;
                }
                if (!res[3]?.hasError) {
                  _userProfileFormData.OtherCertificates = res[3].data as IAppFileInfo[];
                  if (_userProfileFormData.OtherCertificates.length > 0) {
                    /// only single file require in json
                    _userProfileFormData.OtherCertificates = [_userProfileFormData.OtherCertificates[0]];
                  }
                } else {
                  console.log(res[3]?.ErrorDetail);
                  errorMSG = true;
                }
                if (errorMSG) {
                  appContext.ShowAppModal(t("ModalDialogHeader.Error"), t("Error.DocumentError.DocumentUploadError"));
                }
                props.saveUserProfile(AppConstants.SectionKey.AdditionalData, _userProfileFormData, isDataUpdateRequire, func);
              })
              .catch((err) => {
                appContext.ShowAppModal(t("ModalDialogHeader.Error"), t("Error.DocumentError.GenericError"));
                console.log(err);
                appContext.ShowAppLoader(false, "");
              });
          }
        })
        .catch((err) => {
          appContext.ShowAppModal(t("ModalDialogHeader.Error"), t("Error.DocumentError.GenericError"));
          console.log(err);
          appContext.ShowAppLoader(false, "");
        });
    } else {
      func();
    }
  }
  function actionCallbackFun(saveType: SaveTypeEnum) {
    // Validate required fields on Next for all users and block navigation when invalid.
    if (props.isFormEditable && (saveType === SaveTypeEnum.NextSave || saveType === SaveTypeEnum.Next)) {
      const errors = Utility.GetFieldErrors(AppConstants.SectionKey.AdditionalData, _userProfileFormData);
      if (_educationDocs.length === 0) {
        errors.push(t("UserAdditionalData.FormFields.EducationCertificate"));
      }
      if (_otherCertificates.length === 0) {
        errors.push(t("UserAdditionalData.FormFields.Certificate"));
      }
      if (_userProfileFormData?.MaritalStatus?.toLowerCase() !== AppConstants.maritalStatus.Single.toLowerCase() && _maritalDocs.length === 0) {
        errors.push(t("UserAdditionalData.FormFields.MaritalCert"));
      }
      if (_addressDocs.length === 0) {
        errors.push(t("UserAdditionalData.FormFields.ProofOfAddress"));
      }
      if (errors.length > 0) {
        _setFieldErrors(errors);
        _setShowErrors(true);
        return;
      }
    }
    _setFieldErrors([]);
    _setShowErrors(false);
    let actionProps: IReturnAction = Utility.GetActionProps(saveType, props.previousCall, props.nextCall);
    if (actionProps.saveRequired) {
      actionProps.saveRequired = Utility.IsFormUpdated(_isFileUpdated, AppConstants.SectionKey.AdditionalData, props.user, _userProfileFormData);
    }
    callPropSaveDataCallBackFunction(actionProps.saveRequired, actionProps.callBack);
  }

  // Returns a localized error message for a field when it is empty and errors are being shown.
  function getFieldError(isEmpty: boolean, labelKey: string): string {
    if (!_showErrors || !isEmpty) return "";
    return t("ValidationMessage.RequiredField").replace("{field}", t(labelKey));
  }
  const onFileDeleted =
    (attachmentType: string) =>
    (file: IFileInfo | File): Promise<void> => {
      let attachments = [];
      let deletedAttachments = [];
      let idx = -1;
      switch (attachmentType) {
        case AppConstants.AttachmentType.EducationDocs.Type:
          attachments = [..._educationDocs];
          idx = attachments.indexOf(file);
          if (idx !== -1) {
            attachments.splice(idx, 1);
            _setEducationDocs(attachments);
          }
          break;
        case AppConstants.AttachmentType.OtherCertificates.Type:
          attachments = [..._otherCertificates];
          idx = attachments.indexOf(file);
          if (idx !== -1) {
            attachments.splice(idx, 1);
            _setOtherCertificates(attachments);
          }
          break;
        case AppConstants.AttachmentType.MaritalDocs.Type:
          attachments = [..._maritalDocs];
          idx = attachments.indexOf(file);
          if (idx !== -1) {
            attachments.splice(idx, 1);
            _setMaritalDocs(attachments);
          }
          break;
        case AppConstants.AttachmentType.AddressDocs.Type:
          attachments = [..._addressDocs];
          idx = attachments.indexOf(file);
          if (idx !== -1) {
            attachments.splice(idx, 1);
            _setAddressDocs(attachments);
          }
          break;

        default:
          break;
      }
      if (file instanceof File) {
      } else {
        deletedAttachments = [..._deletedDocs];
        deletedAttachments.push(file);
        _setDeletedDocs(deletedAttachments);
      }
      _setIsFileUpdated(true);
      return Promise.resolve(null);
    };
  const onFileDownload = (file: IFileInfo): Promise<void> => {
    appContext.ShowAppLoader(true, "");
    dataProvider
      .downloadUserDoc(props.user.UserId, file.fileId, file.fileName)
      .then((res) => {
        let r = res;
        appContext.ShowAppLoader(false, "");
      })
      .catch((err) => {
        console.log(err);
        appContext.ShowAppLoader(false, "");
        appContext.ShowAppModal(t("ModalDialogHeader.Error"), t("Error.DocumentError.FileDownloadError"));
      });
    return Promise.resolve(null);
  };
  const onFilesAdded =
    (attachmentType: string) =>
    (files: File[]): Promise<void> => {
      let attachments = [];
      switch (attachmentType) {
        case AppConstants.AttachmentType.EducationDocs.Type:
          attachments = [..._educationDocs];
          files.forEach((file) => {
            attachments.push(file);
          });
          _setEducationDocs(attachments);
          break;
        case AppConstants.AttachmentType.OtherCertificates.Type:
          attachments = [..._otherCertificates];
          files.forEach((file) => {
            attachments.push(file);
          });
          _setOtherCertificates(attachments);
          break;
        case AppConstants.AttachmentType.MaritalDocs.Type:
          attachments = [..._maritalDocs];
          files.forEach((file) => {
            attachments.push(file);
          });
          _setMaritalDocs(attachments);
          break;
        case AppConstants.AttachmentType.AddressDocs.Type:
          attachments = [..._addressDocs];
          files.forEach((file) => {
            attachments.push(file);
          });
          _setAddressDocs(attachments);
          break;
        default:
          break;
      }
      _setIsFileUpdated(true);
      return Promise.resolve();
    };

  function _onChangeText(ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string, fieldType: AdditionalFormTXTEnum) {
    let userProfileFormData = JSON.parse(JSON.stringify(_userProfileFormData)) as IUserAdditionalData;
    switch (fieldType) {
      case AdditionalFormTXTEnum.AAddress:
        userProfileFormData.AddressVerification.Address = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.ACEP:
        userProfileFormData.AddressVerification.CEP = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.ACity:
        userProfileFormData.AddressVerification.City = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.AComplement:
        userProfileFormData.AddressVerification.Complement = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.ADistrict:
        userProfileFormData.AddressVerification.District = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.ANumber:
        userProfileFormData.AddressVerification.Number = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.APublicArea:
        userProfileFormData.AddressVerification.PublicArea = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.AState:
        userProfileFormData.AddressVerification.State = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.Email:
        userProfileFormData.Email = Utility.toECFormat(text);
        break;
      case AdditionalFormTXTEnum.Telephone:
        userProfileFormData.Telephone = Utility.toECFormat(text);
        break;
      default:
        break;
    }
    _setUserProfileFormData(userProfileFormData);
  }
  function _onDLLChange(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption, ddlOptionType: AdditionalFormDLLEnum) {
    let userProfileFormData = JSON.parse(JSON.stringify(_userProfileFormData)) as IUserAdditionalData;
    switch (ddlOptionType) {
      case AdditionalFormDLLEnum.ACountry:
        userProfileFormData.AddressVerification.Country = item.key as string;
        break;
      case AdditionalFormDLLEnum.MaritalStatus:
        userProfileFormData.MaritalStatus = item.key as string;
        break;
      case AdditionalFormDLLEnum.EducationLevel:
        userProfileFormData.EducationLevel = item.key as string;
        break;
      case AdditionalFormDLLEnum.APublicArea:
        userProfileFormData.AddressVerification.PublicArea = item.key as string;
        break;
      default:
        break;
    }
    _setUserProfileFormData(userProfileFormData);
  }
  return (
    <>
      <Stack className="formHeader">{t("UserAdditionalData.FormHeader")}</Stack>
      <ActionSection
        resetForm={resetForm}
        {...props}
        isFormEditable={props.isFormEditable}
        previousCallFun={actionCallbackFun}
        nextCallFun={actionCallbackFun}
        submitCallFun={undefined}
      />
      {_showErrors && _fieldErrors.length > 0 && (
        <div className="fieldErrorSummary" role="alert">
          <strong>{t("ModalDialogHeader.ValidationMessage")}</strong>
          <ul>
            {_fieldErrors.map((fieldLabel, idx) => (
              <li key={idx}>{t("ValidationMessage.RequiredField").replace("{field}", fieldLabel)}</li>
            ))}
          </ul>
        </div>
      )}
      <Stack className="formSection formAdditional" horizontal>
        <StackItem className="formSubSection">
          <Stack>
            <StackItem className="fields">
              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.Telephone")}
                  <span className="imp">*</span>
                </StackItem>
                <StackItem className="value">
                  <TextField
                    disabled={!props.isFormEditable}
                    autoComplete="off"
                    value={_userProfileFormData.Telephone}
                    errorMessage={getFieldError(!_userProfileFormData?.Telephone?.trim(), "UserAdditionalData.FormFields.Telephone")}
                    onChange={(ev, text) => {
                      _onChangeText(ev, text, AdditionalFormTXTEnum.Telephone);
                    }}
                  ></TextField>
                </StackItem>
              </Stack>
              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.Email")}
                  <span className="imp">*</span>
                </StackItem>
                <StackItem className="value">
                  <TextField
                    disabled={!props.isFormEditable}
                    autoComplete="off"
                    value={Utility.toECFormat(_userProfileFormData.Email)}
                    errorMessage={getFieldError(!_userProfileFormData?.Email?.trim(), "UserAdditionalData.FormFields.Email")}
                    onChange={(ev, text) => {
                      _onChangeText(ev, text, AdditionalFormTXTEnum.Email);
                    }}
                  ></TextField>
                </StackItem>
              </Stack>

              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.EducationLevel")}
                  <span className="imp">*</span>
                </StackItem>
                <StackItem className="value">
                  <Dropdown
                    disabled={!props.isFormEditable}
                    calloutProps={{ directionalHintFixed: true }}
                    options={_educationLevelOptions}
                    onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
                      _onDLLChange(event, item, AdditionalFormDLLEnum.EducationLevel);
                    }}
                    selectedKey={_userProfileFormData?.EducationLevel}
                    errorMessage={getFieldError(!_userProfileFormData?.EducationLevel?.trim(), "UserAdditionalData.FormFields.EducationLevel")}
                  />
                </StackItem>
              </Stack>
              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.EducationCertificate")}
                  <span className="imp">*</span>
                </StackItem>
                <StackItem className="label" style={{ overflowWrap: "anywhere" }}>
                  <AttachmentComponent
                    texts={Utility.getAttachmentTexts()}
                    fileMode="MultiFile"
                    enableDropZone={true}
                    extensionFilters={AppConstants.fileExtensionAllowed}
                    onFileDeleted={onFileDeleted(AppConstants.AttachmentType.EducationDocs.Type)}
                    onFileDownload={onFileDownload}
                    onFilesAdded={onFilesAdded(AppConstants.AttachmentType.EducationDocs.Type)}
                    readonly={!props.isFormEditable}
                    attachments={_educationDocs}
                  ></AttachmentComponent>
                  {_showErrors && _educationDocs.length === 0 && (
                    <div className="fieldErrorText">
                      {t("ValidationMessage.RequiredField").replace("{field}", t("UserAdditionalData.FormFields.EducationCertificate"))}
                    </div>
                  )}
                  <FileSizeMSG files={_educationDocs} />
                </StackItem>
              </Stack>
              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.Certificate")}
                  <span className="imp">*</span>
                </StackItem>
                <StackItem className="value" style={{ overflowWrap: "anywhere" }}>
                  <AttachmentComponent
                    texts={Utility.getAttachmentTexts()}
                    fileMode="MultiFile"
                    enableDropZone={true}
                    extensionFilters={AppConstants.fileExtensionAllowed}
                    onFileDeleted={onFileDeleted(AppConstants.AttachmentType.OtherCertificates.Type)}
                    onFileDownload={onFileDownload}
                    onFilesAdded={onFilesAdded(AppConstants.AttachmentType.OtherCertificates.Type)}
                    readonly={!props.isFormEditable}
                    attachments={_otherCertificates}
                  ></AttachmentComponent>
                  {_showErrors && _otherCertificates.length === 0 && (
                    <div className="fieldErrorText">
                      {t("ValidationMessage.RequiredField").replace("{field}", t("UserAdditionalData.FormFields.Certificate"))}
                    </div>
                  )}
                  <FileSizeMSG files={_otherCertificates} />
                </StackItem>
              </Stack>
              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.MaritalStatus")}
                  <span className="imp">*</span>
                </StackItem>
                <StackItem className="value">
                  <Dropdown
                    disabled={!props.isFormEditable}
                    calloutProps={{ directionalHintFixed: true }}
                    options={_maritalStatusOptions}
                    onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
                      _onDLLChange(event, item, AdditionalFormDLLEnum.MaritalStatus);
                    }}
                    selectedKey={_userProfileFormData?.MaritalStatus}
                    errorMessage={getFieldError(!_userProfileFormData?.MaritalStatus?.trim(), "UserAdditionalData.FormFields.MaritalStatus")}
                  />
                </StackItem>
              </Stack>
              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.MaritalCert")}
                  {_userProfileFormData?.MaritalStatus &&
                    _userProfileFormData.MaritalStatus.toLowerCase() !== AppConstants.maritalStatus.Single.toLowerCase() && <span className="imp">*</span>}
                </StackItem>
                <StackItem className="value" style={{ overflowWrap: "anywhere" }}>
                  <AttachmentComponent
                    texts={Utility.getAttachmentTexts()}
                    fileMode="MultiFile"
                    enableDropZone={true}
                    extensionFilters={AppConstants.fileExtensionAllowed}
                    onFileDeleted={onFileDeleted(AppConstants.AttachmentType.MaritalDocs.Type)}
                    onFileDownload={onFileDownload}
                    onFilesAdded={onFilesAdded(AppConstants.AttachmentType.MaritalDocs.Type)}
                    readonly={!props.isFormEditable}
                    attachments={_maritalDocs}
                  ></AttachmentComponent>
                  {_showErrors &&
                    _userProfileFormData?.MaritalStatus?.toLowerCase() !== AppConstants.maritalStatus.Single.toLowerCase() &&
                    _maritalDocs.length === 0 && (
                      <div className="fieldErrorText">
                        {t("ValidationMessage.RequiredField").replace("{field}", t("UserAdditionalData.FormFields.MaritalCert"))}
                      </div>
                    )}
                  <FileSizeMSG files={_maritalDocs} />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <StackItem className="formSubSection">
          <Stack>
            <StackItem className="fields">
              <fieldset className="fieldsetsection">
                <legend className="legentStyle">{t("UserAdditionalData.FormFields.AddressSectionName")}</legend>
                <Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.Country")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <Dropdown
                        disabled={!props.isFormEditable}
                        calloutProps={{ directionalHintFixed: true }}
                        options={_addressCountryOptions}
                        selectedKey={_userProfileFormData?.AddressVerification?.Country}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.Country?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.Country",
                        )}
                        onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
                          _onDLLChange(event, item, AdditionalFormDLLEnum.ACountry);
                        }}
                      />
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.CEP")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                        value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.CEP)}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.CEP?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.CEP",
                        )}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.ACEP);
                        }}
                      ></TextField>
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.BirthplaceSection.State")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                        value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.State)}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.State?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.State",
                        )}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.AState);
                        }}
                      ></TextField>
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.City")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                        value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.City)}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.City?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.City",
                        )}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.ACity);
                        }}
                      ></TextField>
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.District")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                        value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.District)}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.District?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.District",
                        )}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.ADistrict);
                        }}
                      ></TextField>
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.PublicArea")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      {/* <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                                              value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.PublicArea)}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.APublicArea);
                        }}
                      ></TextField> */}

                      <Dropdown
                        disabled={!props.isFormEditable}
                        calloutProps={{ directionalHintFixed: true }}
                        options={_publicAreaOptions}
                        selectedKey={_userProfileFormData?.AddressVerification.PublicArea}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.PublicArea?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.PublicArea",
                        )}
                        onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
                          _onDLLChange(event, item, AdditionalFormDLLEnum.APublicArea);
                        }}
                      />
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.Address")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                        value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.Address)}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.Address?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.Address",
                        )}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.AAddress);
                        }}
                      ></TextField>
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.Number")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                        value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.Number)}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.Number?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.Number",
                        )}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.ANumber);
                        }}
                      ></TextField>
                    </StackItem>
                  </Stack>
                  <Stack className="field">
                    <StackItem className="label">
                      {t("UserAdditionalData.FormFields.AddressSection.Complement")}
                      <span className="imp">*</span>
                    </StackItem>
                    <StackItem className="value">
                      <TextField
                        disabled={!props.isFormEditable}
                        autoComplete="off"
                        value={Utility.toECFormat(_userProfileFormData?.AddressVerification?.Complement)}
                        errorMessage={getFieldError(
                          !_userProfileFormData?.AddressVerification?.Complement?.trim(),
                          "UserAdditionalData.FormFields.AddressSection.Complement",
                        )}
                        onChange={(ev, text) => {
                          _onChangeText(ev, text, AdditionalFormTXTEnum.AComplement);
                        }}
                      ></TextField>
                    </StackItem>
                  </Stack>
                </Stack>
              </fieldset>
              <Stack className="field">
                <StackItem className="label">
                  {t("UserAdditionalData.FormFields.ProofOfAddress")}
                  <span className="imp">*</span>
                </StackItem>
                <StackItem className="value" style={{ overflowWrap: "anywhere" }}>
                  <AttachmentComponent
                    texts={Utility.getAttachmentTexts()}
                    fileMode="SingleFile"
                    enableDropZone={true}
                    extensionFilters={AppConstants.fileExtensionAllowed}
                    onFileDeleted={onFileDeleted(AppConstants.AttachmentType.AddressDocs.Type)}
                    onFileDownload={onFileDownload}
                    onFilesAdded={onFilesAdded(AppConstants.AttachmentType.AddressDocs.Type)}
                    readonly={!props.isFormEditable}
                    attachment={_addressDocs.length > 0 ? _addressDocs[0] : null}
                  ></AttachmentComponent>
                  {_showErrors && _addressDocs.length === 0 && (
                    <div className="fieldErrorText">
                      {t("ValidationMessage.RequiredField").replace("{field}", t("UserAdditionalData.FormFields.ProofOfAddress"))}
                    </div>
                  )}
                  <FileSizeMSG files={_addressDocs} />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
      </Stack>
    </>
  );
};
